import {
    Box, Container, useMediaQuery, useTheme
} from "@mui/material";
import {
    LinkedIn as LinkedInIcon
} from '@mui/icons-material';
import {
    FilledButton, InitiaLogo,
    Typography
} from "@initia-digital/component-library";
import { prodBase } from '@initia-digital/colors';

import { BasicPublicAppBarPage } from "../layouts/BasicPublicAppBarPage";

export const ClosedPage = () => {
    // --------------------------------------------------

    const theme = useTheme();
    const isSmallerThanMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <BasicPublicAppBarPage>
            <Container
                maxWidth="sm"
                sx={{
                    display: "flex", flex: 1,
                    alignItems: "center", justifyContent: "center",
                    pb: "100px", px: "50px"
                }}
            >
                <Box display="flex" flexDirection="column">
                    <Box
                        display="flex" flexDirection="row"
                        alignItems="center" justifyContent="center"
                    >
                        <InitiaLogo width="100px" />
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        sx={{
                            pb: '24px',
                            mt: '40px',
                            textAlign: 'center'
                        }}
                    >
                        <Box
                        >
                            <Typography
                                fontSize="1.2rem"
                                fontWeight={700}
                                color={prodBase.primary.contrastText}
                            >
                                Thanks for your interest!
                            </Typography>
                        </Box>
                        <Box
                            my="10px"
                        >
                            <Typography
                                fontSize="1rem"
                                fontWeight={400}
                                color={prodBase.primary.contrastText}
                            >
                                Our contact form is currently closed.
                            </Typography>
                        </Box>
                        <Typography
                            fontSize="0.75rem"
                            fontWeight={300}
                            color={prodBase.secondary.main}
                        >
                            Connect with us on LinkedIn to see what we're up to
                        </Typography>
                        <Box
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            justifyContent="center"
                            flex={1}
                            my="25px"
                        >
                            <FilledButton
                                backgroundColor={'#0072b1'}
                                color={'white'}
                                disabled={false}
                                size={isSmallerThanMd ? "small" : "medium"}
                                onClick={() => window.open(`https://www.linkedin.com/company/initia-ltd`, '_blank')}
                                startIcon={<LinkedInIcon />}
                            >
                                LinkedIn
                            </FilledButton>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </BasicPublicAppBarPage>
    );
}; 